import React from "react";
import { UserPlus, Gamepad2, TrendingUp, Trophy } from "lucide-react";
import { HOW_IT_WORKS } from "../mock";

const icons = [UserPlus, Gamepad2, TrendingUp, Trophy];

const HowItWorks = ({ showHeader = true }) => {
  return (
    <section id="how-it-works" className="relative py-24 px-5 bg-[#2a2249] overflow-hidden">
      <div className="absolute inset-0 grid-bg opacity-20" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[300px] rounded-full bg-[#5b5baf]/10 blur-[120px]" />

      <div className="relative max-w-7xl mx-auto">
        {showHeader && (
          <div className="text-center mb-20">
            <p className="text-[#edbb23] font-extrabold tracking-[0.3em] text-sm mb-3">GET STARTED</p>
            <h2 className="text-4xl md:text-5xl font-black text-white">How It Works</h2>
            <p className="mt-4 text-[#b7b0d6] max-w-xl mx-auto">
              Four simple steps to start climbing the leaderboard and winning rewards.
            </p>
          </div>
        )}

        <div className="relative grid sm:grid-cols-2 lg:grid-cols-4 gap-7 lg:gap-6">
          {HOW_IT_WORKS.map((s, i) => {
            const Icon = icons[i];
            return (
              <div key={s.step} className="relative group">
                {/* connector */}
                {i < HOW_IT_WORKS.length - 1 && (
                  <div className="hidden lg:flex absolute top-14 left-[calc(100%-0.5rem)] w-6 items-center justify-center z-10">
                    <span className="w-2 h-2 rounded-full bg-[#edbb23] shadow-[0_0_12px_rgba(237,187,35,0.8)]" />
                  </div>
                )}

                <div className="relative h-full rounded-2xl bg-gradient-to-b from-[#3a3068] to-[#312a5b] border border-[#473c7d] p-7 pt-10 overflow-hidden transition-all duration-300 hover:-translate-y-2 hover:border-[#edbb23]/50 hover:shadow-[0_20px_40px_-15px_rgba(0,0,0,0.5)]">
                  {/* top accent bar */}
                  <span className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#edbb23] to-[#f4cf52] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-300" />

                  {/* big watermark number */}
                  <span className="absolute -bottom-4 -right-1 text-8xl font-black text-white/[0.04] select-none leading-none">
                    {s.step}
                  </span>

                  {/* step badge */}
                  <div className="flex items-center gap-3 mb-6">
                    <span className="w-8 h-8 rounded-lg bg-[#edbb23] text-[#251e44] text-sm font-black flex items-center justify-center">
                      {s.step}
                    </span>
                    <span className="h-[2px] flex-1 bg-[#473c7d]" />
                  </div>

                  {/* icon */}
                  <div className="relative mb-5 w-16 h-16 rounded-2xl bg-[#251e44] border border-[#473c7d] flex items-center justify-center text-[#edbb23] transition-all duration-300 group-hover:bg-gradient-to-br group-hover:from-[#5b5baf] group-hover:to-[#4a4a94] group-hover:text-white group-hover:scale-105">
                    <Icon size={30} strokeWidth={2.2} />
                  </div>

                  <h3 className="relative text-xl font-extrabold text-white mb-2">{s.title}</h3>
                  <p className="relative text-sm text-[#b7b0d6] leading-relaxed">{s.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
